import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
    state: () => {
        return {
            mobile: false,
            stages: []
        }
    },
    getters: {
        //
    },
    actions: {
        toggleMobile(delta) {
            delta != null ? this.mobile = delta : this.mobile = !this.mobile
        },
        async getEventStages() {
            return axios.get('/api/event/stages').then(stages => {
                this.stages = stages.data
            }).catch(error => {
                console.error(error)
            })
        }
    }
})
